export default function SearchScreen() {
  return null;
}
